import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Grid, Header, Card } from "semantic-ui-react";
import MediaItem from "~/models/Media/MediaItem";
import FlyerMediaItem from "./FlyerMediaItem";

const FlyerBucket = observer(({ mediaItems, onDragEnd, t, useTranslation }) => (
  <Grid>
    <Grid.Row className="flyer-additional-bucket-wrap">
      <Grid.Column>
        <Header className="flyer-additional-bucket-helper">
          {useTranslation
            ? t("clientPanelMisc:dragFromBucketToFlyerSection")
            : "Drag from this bucket into the Flyer section above"}
        </Header>
        <Card.Group itemsPerRow={6}>
          {mediaItems.map(mediaItem => (
            <FlyerMediaItem key={mediaItem.mediaItemId} mediaItem={mediaItem} source="bucket" onDragEnd={onDragEnd} />
          ))}
        </Card.Group>
      </Grid.Column>
    </Grid.Row>
  </Grid>
));

FlyerBucket.propTypes = {
  mediaItems: PropTypes.arrayOf(PropTypes.instanceOf(MediaItem)).isRequired,
  onDragEnd: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  // @todo Remove when we will find another solution for the translation at the provider panel
  useTranslation: PropTypes.bool,
};

FlyerBucket.defaultProps = {
  useTranslation: false,
};

export default withTranslation()(FlyerBucket);
